import { IssueTypes } from '../../../cimsPage/instances/issues'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  page: IssueTypes,
  object: 'Type',
  create: '00681623-990f-4598-a811-161506a452d2',
  edit: 'eb1818f0-6236-42df-b5e3-823fb51ce3e8',
  removeRestore: '10c59e84-2255-4c16-bac8-8234a2429404',
  view: '8c9ea5c3-75a3-4ccc-9e06-91d89c3e0437',
})

export const CreateIssueType = Create
export const EditIssueType = Edit
export const RemoveRestoreIssueType = RemoveRestore
export const ViewIssueType = View

export type IssueTypePermission =
  | typeof CreateIssueType
  | typeof EditIssueType
  | typeof RemoveRestoreIssueType
  | typeof ViewIssueType
